var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like"},[_c('ul',{staticClass:"font14"},[_c('li',{staticClass:"rac",on:{"click":_vm.toDetail}},[_c('span',{staticClass:"showE"},[_vm._v("金属非金属矿山企业主要负责人(露天矿山)")]),_vm._v(" "),_c('span',[_vm._v("03-14 07:00")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }